import React, { useState, useEffect, useCallback } from 'react';
import {
  Plus, Search, Eye, Trash2, Edit3, Send
} from 'lucide-react';
import API from '../../api';

const KATEGORI = [
  { value: 'penelitian', label: '🔬 Penelitian', color: '#6366f1' },
  { value: 'pengembangan', label: '⚙️ Pengembangan', color: '#f59e0b' },
  { value: 'prototipe', label: '🧪 Prototipe', color: '#10b981' },
  { value: 'testing', label: '📋 Testing', color: '#3b82f6' },
  { value: 'review', label: '📝 Review', color: '#8b5cf6' },
];

const STATUS = [
  { value: 'aktif', label: '🟢 Aktif', color: '#10b981' },
  { value: 'selesai', label: '✅ Selesai', color: '#059669' },
  { value: 'ditunda', label: '⏸️ Ditunda', color: '#f59e0b' },
  { value: 'batal', label: '❌ Batal', color: '#ef4444' },
];

export default function ActivityRD() {
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [filterStatus, setFilterStatus] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [detail, setDetail] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await API.get('/activity-rd', { params: { search, status: filterStatus } });
      setActivities(data);
    } catch (e) { console.error(e); }
    setLoading(false);
  }, [search, filterStatus]);

  useEffect(() => { load(); }, [load]);

  const handleDelete = async (id) => {
    if (!window.confirm('Hapus activity ini?')) return;
    try { await API.delete(`/activity-rd/${id}`); load(); } catch (e) { alert('Gagal: ' + e.message); }
  };

  const handleSave = async (form) => {
    try {
      if (editData) await API.put(`/activity-rd/${editData.id}`, form);
      else await API.post('/activity-rd', form);
      setShowModal(false); setEditData(null); load();
    } catch (e) { alert('Gagal: ' + e.message); }
  };

  const openDetail = async (id) => {
    try {
      const [aRes, nRes] = await Promise.all([
        API.get(`/activity-rd/${id}`),
        API.get(`/activity-rd/${id}/notes`),
      ]);
      setDetail({ ...aRes.data, notes: nRes.data });
    } catch (e) { alert('Gagal'); }
  };

  const getCat = (k) => KATEGORI.find(c => c.value === k) || KATEGORI[0];
  const getSts = (s) => STATUS.find(c => c.value === s) || STATUS[0];

  return (
    <div style={{ padding: 24 }}>
      <div style={{ marginBottom: 20 }}>
        <h1 style={{ fontSize: 24, fontWeight: 700, color: '#1e293b', margin: 0 }}>🔬 Activity R&D</h1>
        <p style={{ fontSize: 14, color: '#6b7280', margin: '4px 0 0' }}>Kegiatan Tim Research & Development</p>
      </div>

      {/* Filter Bar */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 16, alignItems: 'center', flexWrap: 'wrap' }}>
        <div style={{ position: 'relative', flex: '1 1 200px' }}>
          <Search size={15} style={{ position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)', color: '#9ca3af' }} />
          <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Cari activity..."
            style={{ width: '100%', padding: '9px 12px 9px 34px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 14 }} />
        </div>
        <select value={filterStatus} onChange={e => setFilterStatus(e.target.value)}
          style={{ padding: '9px 14px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 14 }}>
          <option value="">Semua Status</option>
          {STATUS.map(s => <option key={s.value} value={s.value}>{s.label}</option>)}
        </select>
        <button onClick={() => { setEditData(null); setShowModal(true); }}
          style={{ display: 'flex', alignItems: 'center', gap: 5, padding: '9px 16px', background: '#6366f1', color: '#fff', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: 'pointer' }}>
          <Plus size={15} /> Tambah
        </button>
      </div>

      {/* List */}
      <div style={{ background: '#fff', borderRadius: 12, overflow: 'hidden', boxShadow: '0 1px 3px rgba(0,0,0,0.06)' }}>
        {loading ? (
          <div style={{ padding: 40, textAlign: 'center', color: '#9ca3af', fontSize: 14 }}>Memuat...</div>
        ) : activities.length === 0 ? (
          <div style={{ padding: 40, textAlign: 'center', color: '#9ca3af', fontSize: 14 }}>Tidak ada data</div>
        ) : activities.map(a => {
          const cat = getCat(a.kategori);
          const sts = getSts(a.status);
          return (
            <div key={a.id} style={{ padding: '14px 18px', borderBottom: '1px solid #f3f4f6', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div style={{ flex: 1 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
                  <span style={{ fontSize: 14, fontWeight: 600, color: '#1e293b' }}>{a.judul}</span>
                  <span style={{ fontSize: 11, fontWeight: 600, padding: '2px 8px', borderRadius: 6, background: cat.color + '15', color: cat.color }}>{cat.label}</span>
                  <span style={{ fontSize: 11, fontWeight: 600, padding: '2px 8px', borderRadius: 6, background: sts.color + '15', color: sts.color }}>{sts.label}</span>
                </div>
                <div style={{ display: 'flex', gap: 12, fontSize: 12, color: '#6b7280' }}>
                  <span>📅 {a.created_at?.substring(0, 10)}</span>
                  {a.created_nama && <span>👤 {a.created_nama}</span>}
                  {a.target_date && <span>🎯 Target: {a.target_date}</span>}
                </div>
              </div>
              <div style={{ display: 'flex', gap: 4 }}>
                <button onClick={() => openDetail(a.id)} style={{ background: '#eff6ff', border: 'none', borderRadius: 6, padding: 6, cursor: 'pointer' }}><Eye size={15} color="#3b82f6" /></button>
                <button onClick={() => { setEditData(a); setShowModal(true); }} style={{ background: '#fef3c7', border: 'none', borderRadius: 6, padding: 6, cursor: 'pointer' }}><Edit3 size={15} color="#f59e0b" /></button>
                <button onClick={() => handleDelete(a.id)} style={{ background: '#fef2f2', border: 'none', borderRadius: 6, padding: 6, cursor: 'pointer' }}><Trash2 size={15} color="#ef4444" /></button>
              </div>
            </div>
          );
        })}
      </div>

      {showModal && <ActivityRDModal editData={editData} onClose={() => { setShowModal(false); setEditData(null); }} onSave={handleSave} />}
      {detail && <ActivityRDDetail data={detail} onClose={() => setDetail(null)} />}
    </div>
  );
}

// ============ MODAL ============
function ActivityRDModal({ editData, onClose, onSave }) {
  const [form, setForm] = useState({
    judul: editData?.judul || '',
    deskripsi: editData?.deskripsi || '',
    kategori: editData?.kategori || 'penelitian',
    status: editData?.status || 'aktif',
    target_date: editData?.target_date || '',
  });
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.judul.trim()) return alert('Judul wajib diisi');
    onSave(form);
  };
  const inputS = { width: '100%', padding: '8px 10px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 14 };
  const labelS = { fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 4, display: 'block' };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
      <div style={{ background: '#fff', borderRadius: 12, width: '90%', maxWidth: 500, maxHeight: '90vh', overflow: 'auto' }}>
        <div style={{ padding: '14px 18px', borderBottom: '1px solid #e5e7eb', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h3 style={{ fontSize: 16, fontWeight: 700, margin: 0 }}>{editData ? 'Edit' : 'Tambah'} Activity R&D</h3>
          <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: 20, cursor: 'pointer' }}>×</button>
        </div>
        <form onSubmit={handleSubmit} style={{ padding: 18 }}>
          <div style={{ marginBottom: 12 }}><label style={labelS}>Judul *</label><input style={inputS} value={form.judul} onChange={e => setForm({ ...form, judul: e.target.value })} /></div>
          <div style={{ marginBottom: 12 }}><label style={labelS}>Deskripsi</label><textarea style={{ ...inputS, height: 80 }} value={form.deskripsi} onChange={e => setForm({ ...form, deskripsi: e.target.value })} /></div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 12 }}>
            <div><label style={labelS}>Kategori</label>
              <select style={inputS} value={form.kategori} onChange={e => setForm({ ...form, kategori: e.target.value })}>
                {KATEGORI.map(k => <option key={k.value} value={k.value}>{k.label}</option>)}
              </select></div>
            <div><label style={labelS}>Status</label>
              <select style={inputS} value={form.status} onChange={e => setForm({ ...form, status: e.target.value })}>
                {STATUS.map(s => <option key={s.value} value={s.value}>{s.label}</option>)}
              </select></div>
          </div>
          <div style={{ marginBottom: 12 }}><label style={labelS}>Target Date</label><input style={inputS} type="date" value={form.target_date} onChange={e => setForm({ ...form, target_date: e.target.value })} /></div>
          <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
            <button type="button" onClick={onClose} style={{ padding: '8px 16px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 14, cursor: 'pointer' }}>Batal</button>
            <button type="submit" style={{ padding: '8px 16px', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 600, background: '#6366f1', color: '#fff', cursor: 'pointer' }}>Simpan</button>
          </div>
        </form>
      </div>
    </div>
  );
}

// ============ DETAIL + NOTES ============
function ActivityRDDetail({ data, onClose }) {
  const [notes, setNotes] = useState(data.notes || []);
  const [newNote, setNewNote] = useState('');
  const cat = KATEGORI.find(c => c.value === data.kategori) || KATEGORI[0];
  const sts = STATUS.find(c => c.value === data.status) || STATUS[0];

  const handleAddNote = async () => {
    if (!newNote.trim()) return;
    try {
      const { data: res } = await API.post(`/activity-rd/${data.id}/notes`, { isi: newNote, is_manager: false });
      setNotes(prev => [...prev, { id: res.id, isi: newNote, user_nama: 'Anda', is_manager: false, created_at: new Date().toISOString() }]);
      setNewNote('');
    } catch (e) { alert('Gagal'); }
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
      <div style={{ background: '#fff', borderRadius: 12, width: '90%', maxWidth: 550, maxHeight: '90vh', overflow: 'auto' }}>
        <div style={{ padding: '14px 18px', borderBottom: '1px solid #e5e7eb', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h3 style={{ fontSize: 16, fontWeight: 700, margin: 0 }}>🔬 Detail Activity R&D</h3>
          <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: 20, cursor: 'pointer' }}>×</button>
        </div>
        <div style={{ padding: 18 }}>
          <div style={{ marginBottom: 16 }}>
            <div style={{ fontSize: 16, fontWeight: 700, color: '#1e293b', marginBottom: 6 }}>{data.judul}</div>
            <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
              <span style={{ fontSize: 12, fontWeight: 600, padding: '3px 10px', borderRadius: 6, background: cat.color + '15', color: cat.color }}>{cat.label}</span>
              <span style={{ fontSize: 12, fontWeight: 600, padding: '3px 10px', borderRadius: 6, background: sts.color + '15', color: sts.color }}>{sts.label}</span>
            </div>
            {data.deskripsi && <div style={{ fontSize: 13, color: '#6b7280', marginBottom: 8, whiteSpace: 'pre-wrap' }}>{data.deskripsi}</div>}
            <div style={{ display: 'flex', gap: 12, fontSize: 12, color: '#9ca3af' }}>
              <span>📅 {data.created_at?.substring(0, 10)}</span>
              {data.created_nama && <span>👤 {data.created_nama}</span>}
              {data.target_date && <span>🎯 {data.target_date}</span>}
            </div>
          </div>

          {/* Notes / Komunikasi */}
          <div style={{ borderTop: '1px solid #e5e7eb', paddingTop: 14 }}>
            <div style={{ fontSize: 14, fontWeight: 600, color: '#374151', marginBottom: 8 }}>💬 Diskusi & Catatan</div>
            <div style={{ maxHeight: 250, overflowY: 'auto', marginBottom: 10 }}>
              {notes.length === 0 ? (
                <div style={{ fontSize: 13, color: '#9ca3af', padding: '4px 0' }}>Belum ada catatan</div>
              ) : notes.map(n => (
                <div key={n.id} style={{ padding: '8px 10px', background: n.is_manager ? '#fef3c7' : '#eff6ff', borderRadius: 8, marginBottom: 6, borderLeft: `3px solid ${n.is_manager ? '#f59e0b' : '#3b82f6'}` }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 2 }}>
                    <span style={{ fontSize: 12, fontWeight: 600, color: n.is_manager ? '#92400e' : '#1e40af' }}>{n.user_nama} {n.is_manager && '⭐'}</span>
                    <span style={{ fontSize: 11, color: '#9ca3af' }}>{n.created_at}</span>
                  </div>
                  <div style={{ fontSize: 13, color: '#374151', whiteSpace: 'pre-wrap' }}>{n.isi}</div>
                </div>
              ))}
            </div>
            <div style={{ display: 'flex', gap: 6 }}>
              <textarea value={newNote} onChange={e => setNewNote(e.target.value)} placeholder="Tulis catatan atau balasan..."
                style={{ flex: 1, padding: '8px 10px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 13, resize: 'none', height: 50 }} />
              <button type="button" onClick={handleAddNote} disabled={!newNote.trim()}
                style={{ padding: '8px 12px', background: newNote.trim() ? '#6366f1' : '#e5e7eb', color: newNote.trim() ? '#fff' : '#9ca3af', border: 'none', borderRadius: 6, fontSize: 13, fontWeight: 600, cursor: newNote.trim() ? 'pointer' : 'not-allowed', alignSelf: 'flex-end' }}>
                <Send size={14} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
